import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSetContentMutation, useUpdContentMutation } from "../../../../../store/admin/adminContentsApiSlice";
import { MultiInputBox } from "../../../../../components/admin/regist/multiInputBox";
export interface Props {detail : any}
export const RegistVideo:React.FC<Props> = ({detail}) => {
    const {contentsId} = useParams()
    const navigate = useNavigate()
    const [setContentApi] = useSetContentMutation()
    const [updContentApi] = useUpdContentMutation()
    const [data, setData] = useState<any>({subjectKr : '', subjectEn : '', linkKr : '', linkEn : ''})
    const handleSave = async() => {
        const formData : any = new FormData()
        if(contentsId !== 'regist'){formData.append('prom_idx', contentsId)}
        formData.append('promCreator', 1)
        formData.append('promContentType', 4)
        formData.append('promSubjectKr', data?.subjectKr)
        formData.append('promSubjectEn', data?.subjectEn)
        formData.append('promVideoKr', data?.linkKr)
        formData.append('promVideoEn', data?.linkEn)
        if(contentsId === 'regist'){
            const result : any = await setContentApi(formData)
            if(result.data.result === true){alert("등록이 완료되었습니다.");navigate('/dotsAdmin/prCenter/4')}
        }else{
            const result : any = await updContentApi(formData)
            if(result.data.result === true){alert("수정이 완료되었습니다.");navigate(-1)}
        }
    }
    useEffect(()=>{
        if(contentsId !== 'regist' && detail){
            setData((prev:any)=>({...prev, subjectKr : detail?.prom_subject_kr, subjectEn : detail?.prom_subject_en,
            linkKr : detail?.prom_video_url_kr,  linkEn : detail?.prom_video_url_en}))
        }
    }, [detail])
    return(
        <>
         <div className="contentBox upload">
            <h3>PR Center</h3>
            <div className="flexWrap">
                <div className="flexBox">
                    <h4>
                        List of PR Video
                    </h4>
                </div>
                <div>
                    <button className="blackBtn">목록으로</button>
                    <button className="blueBtn" onClick={handleSave}>저장하기</button>
                </div>
            </div>
            
            <table>
                <tbody>
                    <MultiInputBox 
                        setData={setData} 
                        title={'제목'} 
                        krValue={data?.subjectKr} 
                        enValue={data?.subjectEn} 
                        krName={'subjectKr'} 
                        enName={'subjectEn'} 
                        placeHolder={'영상'}
                    />
                    <MultiInputBox 
                        setData={setData} 
                        title={'영상 링크'} 
                        krValue={data?.linkKr} 
                        enValue={data?.linkEn} 
                        krName={'linkKr'} 
                        enName={'linkEn'} 
                        placeHolder={'영상 링크'}
                    />
                </tbody>
            </table>

        </div>
        </>
    )
}